import MatchesOverview from "./MatchesOverview";

export default function RoasterTab({ program }) {
    return (
        <div>
            <MatchesOverview programId={program.id}/>
        </div>
    )
}
